import { IRecentNotificationSetAction } from './types';
import { AT_RECENT_NOTIFICATION_UPDATE } from './constants';

export const recentNotificationSetAction = (
    recentNotification: number
): IRecentNotificationSetAction => ({
    type: AT_RECENT_NOTIFICATION_UPDATE,
    recentNotification
});
